export const PAGE_ROUTES = {
    DASHBOARD:'dashboard',
}